export default __webpack_public_path__ + "static/media/robotoslab-bold.51f4a5c5.ttf";